import React, { useEffect } from "react";
import WithAuthLayout from "../routeProtector/withAuth";
import CustomLayout from "../components/layout/CustomLayout";
import useDocumentTitle from "../utils/useDocumentTitle";

import { Tabs } from "antd";
import PrivacyAndPolicies from "../components/CMS/PrivacyAndPolicies";
import TermsAndConditions from "../components/CMS/TermsAndConditions";
const CMSPage = () => {

  const onTabChange = (key) => {
    console.log(key);
  };

  const items = [
    {
      key: "1",
      label: "Privacy Policies",
      children: <PrivacyAndPolicies />,
    },
    {
      key: "2",
      label: "Terms & Conditions",
      children: <TermsAndConditions />,
    },
  ];

  useDocumentTitle("CMS Page");

  return (
    <div>
      <CustomLayout>
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onTabChange}
        />
      </CustomLayout>
    </div>
  );
};

export default WithAuthLayout(CMSPage);
